module.exports = __webpack_public_path__ + "img/chatCamera.e0cabc6.svg";